/**
 * Z-indexes that need to be used in js (component template)
 *
 * @WARN Do not forget about zIndex in z-index.scss
 */
export const Z_INDEX = {
  zSavedMessagesDropdown: 100,
  zFilterDropdown: 100,
  zSelect: 100,
  zSessionTipDropdownInsideTab: 120,
  zSessionTipDropdownOutsideTab: 131,
  zProviderDropdown: 'auto',
  zCreditLimitInfoDropdown: 'auto',
  zUserMenuDropdown: 'auto',
  zSideBarDropdown: 'auto',
};
